import { AppLayout } from '@cloudscape-design/components';
import { Flashbar } from '@cloudscape-design/components';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { useUserAlias } from 'src/common/hooks/useUserAlias';
import { PrivateRoute } from 'src/common/PrivateRoute';
import { useFlashbar } from 'src/common/hooks/useFlashbar';
import TopNav from '../../navigation/TopNav';
import TopNavOrion from '../../navigation/TopNavOrion';
import OrionSidenav from '../../navigation/OrionSidenav';
import { useOrionUI } from 'src/common/hooks/useOrionUI';
import styles from './styles.module.scss';
import ToolsNav from 'src/components/navigation/ToolsNav';
import { generateBreadcrumbItems } from './utils';
import { useChatWidget } from 'src/provider/ChatWidgetProvider';
import { Breadcrumbs } from 'src/common/Breadcrumbs';

const ORION_LAYOUT_STYLE: React.CSSProperties = {
  display: 'flex',
  minHeight: 'calc(100vh - 56px)',
};
const ORION_CONTENT_STYLE: React.CSSProperties = { flex: 1 };

const HEADER_ID = 'h';

const AppContainer = () => {
  const { alias: userAlias } = useUserAlias();
  const { flashbarMessages } = useFlashbar();
  const location = useLocation();
  const isLandingPage = location.pathname === '/';
  const { openChat, isEnabled: isAIEnabled } = useChatWidget();
  const breadcrumbItems = generateBreadcrumbItems();
  const isOrion = useOrionUI();

  const SIM_ISSUE_LINK =
    'https://sim.amazon.com/issues/create?assignedFolder=9734f5a7-1b6a-4016-909d-ffbc99a50513';
  const WIKI_ABOUT_LINK =
    'https://w.amazon.com/bin/view/IPAT_COMPASS_Wki/Product_Program_team/ControllershipHub/#HWhoisourCustomer3F';

  const navProps = {
    userAlias,
    issueLink: SIM_ISSUE_LINK,
    aboutLink: WIKI_ABOUT_LINK,
    onAskAI: isAIEnabled ? openChat : undefined,
  };

  return (
    <div className={styles.root}>
      <div id={HEADER_ID} className={styles.topNavigation}>
        {isOrion ? <TopNavOrion {...navProps} /> : <TopNav {...navProps} />}
      </div>
      <div className={styles.appLayout}>
        {isOrion ? (
          <div style={ORION_LAYOUT_STYLE}>
            <OrionSidenav />
            <div style={ORION_CONTENT_STYLE}>
              <AppLayout
                breadcrumbs={
                  !isLandingPage ? (
                    <div className={styles.breadcrumbsContainer}>
                      <Breadcrumbs items={breadcrumbItems} />
                    </div>
                  ) : undefined
                }
                toolsHide
                navigationHide
                toolsWidth={500}
                tools={<ToolsNav />}
                navigationOpen={false}
                disableContentPaddings={true}
                headerSelector={`#${HEADER_ID}`}
                maxContentWidth={Number.MAX_VALUE}
                content={<PrivateRoute />}
              />
            </div>
          </div>
        ) : (
          <AppLayout
            breadcrumbs={
              !isLandingPage ? (
                <div className={styles.breadcrumbsContainer}>
                  <Breadcrumbs items={breadcrumbItems} />
                </div>
              ) : undefined
            }
            toolsHide
            navigationHide
            toolsWidth={500}
            notifications={<Flashbar items={flashbarMessages} stackItems />}
            tools={<ToolsNav />}
            navigationOpen={false}
            disableContentPaddings={true}
            headerSelector={`#${HEADER_ID}`}
            maxContentWidth={Number.MAX_VALUE}
            content={<PrivateRoute />}
          />
        )}
      </div>
    </div>
  );
};

export default AppContainer;
